import Resource from '@/plugins/sdk/Resource'
import { STRING, UUID } from '@/plugins/sdk/fields'
// import Account from '@/plugins/sdk/resources/Account'
// import CarrierService from '@/plugins/sdk/resources/Account/CarrierSetting'

export default class extends Resource {
  static name = 'dangerous_goods'

  static get fields () {
    return {
      'id': new UUID(),
      'un_number': new STRING(),
      'description': new STRING(),
      'packing_group': new STRING(),
      'class': new STRING()
    }
  }
}
